var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "useimage-b",
    d: "M40,0 C17.90861,0 0,17.90861 0,40 C0,62.09139 17.90861,80 40,80 C62.09139,80 80,62.09139 80,40 C80,17.90861 62.09139,0 40,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "useimage-a",
    width: "117.5%",
    height: "117.5%",
    x: "-8.8%",
    y: "-6.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "useimage-c",
    d: "M16.3029141,41.1849141 L0.702914062,25.5849141 C-0.234304687,24.6476953 -0.234304687,23.1281016 0.702914062,22.1907891 L4.09694531,18.7966641 C5.03416406,17.8593516 6.55385156,17.8593516 7.49107031,18.7966641 L17.9999766,29.3054766 L40.5088828,6.79666406 C41.4461016,5.85944531 42.9657891,5.85944531 43.9030078,6.79666406 L47.2970391,10.1907891 C48.2342578,11.1280078 48.2342578,12.6476016 47.2970391,13.5849141 L19.6970391,41.1850078 C18.7597266,42.1222266 17.2401328,42.1222266 16.3029141,41.1849141 L16.3029141,41.1849141 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#useimage-a)",
    xlinkHref: "#useimage-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#34A001",
    xlinkHref: "#useimage-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(16 16)",
    xlinkHref: "#useimage-c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAccept);
export default __webpack_public_path__ + "static/media/camera_accept.66d4c5531627192a795856eb3a3dca51.svg";
export { ForwardRef as ReactComponent };